import React from "react";
import { StyledLoader } from "../styles/Loader";

function Loader() {
  return (
    <StyledLoader>
      <div></div>
    </StyledLoader>
  );
}

export default Loader;
